import React from "react";

const TONE = {
  "Filed":               { fg: "#15201C", bg: "transparent", bd: "#B8B0A0" },
  "Under Review":        { fg: "#15201C", bg: "transparent", bd: "#B8B0A0" },
  "Neutral Assigned":    { fg: "#15201C", bg: "transparent", bd: "#B8B0A0" },
  "Notice Sent":         { fg: "#C2542A", bg: "transparent", bd: "#C2542A" },
  "In Mediation":        { fg: "#C2542A", bg: "transparent", bd: "#C2542A" },
  "Hearing Scheduled":   { fg: "#C2542A", bg: "transparent", bd: "#C2542A" },
  "Awaiting Award":      { fg: "#C2542A", bg: "transparent", bd: "#C2542A" },
  "Resolved":            { fg: "#1F3A34", bg: "rgba(110,139,90,0.18)", bd: "#6E8B5A" },
  "Closed":              { fg: "#1F3A34", bg: "rgba(110,139,90,0.18)", bd: "#6E8B5A" },
};

export default function StatusChip({ status, className = "" }) {
  const t = TONE[status] || { fg: "#15201C", bg: "transparent", bd: "#B8B0A0" };
  return (
    <span
      data-testid={`status-chip-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center gap-2 px-2.5 py-1 text-[11px] tracking-[0.08em] font-mono uppercase ${className}`}
      style={{ color: t.fg, backgroundColor: t.bg, border: `1px solid ${t.bd}`, borderRadius: 2 }}
    >
      <span className="h-1.5 w-1.5" style={{ backgroundColor: t.fg, borderRadius: 1 }} />
      {status}
    </span>
  );
}
